<script setup lang="ts">
const { t } = useI18n()

useSeoMeta({
  title: t('pages.index.meta.title'),
  description: t('pages.index.meta.description'),
  // Set explicitly, otherwise @nuxtjs/seo infers og:title/og:description
  // from the page title and meta description.
  ogTitle: t('pages.index.meta.ogTitle'),
  ogDescription: t('pages.index.meta.ogDescription'),
})

useHead({
  titleTemplate: '',
})

defineOgImage({
  component: 'Default',
  subtitle: t('hero.subtitle'),
})
</script>

<template>
  <main>
    <HomepageHero />
    <HomepageEetPromo />
    <HomepageAbout />
    <HomepageFaq />
    <HomepagePricing />
    <HomepageContact />
  </main>
</template>
